﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalAppPackage`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetProductListAll' },
  { name: 'GetStateList' },
  { name: 'GetAnswerYesNoDontKnow' },
  { name: 'GetAnswerYesNo' },
  { name: 'GetAgeList' },
  { name: 'GetServiceForms' },
  { name: 'GetAnnuityTypeList' },
  { name: 'GetFundingSourceList' },
  { name: 'SaveIsd' },
  { name: 'SaveCareer' },
  { name: 'GetSilverGuardTypeList' },
  { name: 'GetGenderList' },
  { name: 'PrintForm' },
  { name: 'GetServiceFormText' },
  { name: 'PrintCheckList' },
  { name: 'GetCheckoutSituationForms' },
  { name: 'GetReceiptSituationForms' },
  { name: 'GetOrderDetails' },
  { name: 'SubmitOrder' },
  { name: 'GetCheckoutSelections' },
  { name: 'SetAdditionalInformation' },
  { name: 'GetCheckoutSituationId' },
  { name: 'SetOrderForm' },
  { name: 'ChangeOrderForm' },
  { name: 'GetOrderSituationForms' },
  { name: 'PrintAllForms' },
  { name: 'GetStatesWithFAST' },
  { name: 'GetAppPackageForms' },
  { name: 'GetMiscellaneousForms' },
]);

const GetProductListAll = () => api.endpoints.GetProductListAll.post();
const GetStateList = () => api.endpoints.GetStateList.post();
const GetAnswerYesNoDontKnow = () => api.endpoints.GetAnswerYesNoDontKnow.post();
const GetAnswerYesNo = () => api.endpoints.GetAnswerYesNo.post();
const GetAgeList = () => api.endpoints.GetAgeList.post();
const GetServiceForms = (body) => api.endpoints.GetServiceForms.post(body);
const GetAnnuityTypeList = (productID) =>
  api.endpoints.GetAnnuityTypeList.postMultipleQueryString([
    {
      queryParam: 'productID',
      queryVal: productID,
    },
  ]);
const GetFundingSourceList = () => api.endpoints.GetFundingSourceList.post();
const SaveIsd = (body) => api.endpoints.SaveIsd.post(body);
const SaveCareer = (body) => api.endpoints.SaveCareer.post(body);
const GetSilverGuardTypeList = () => api.endpoints.GetSilverGuardTypeList.post();
const GetGenderList = () => api.endpoints.GetGenderList.post();
const PrintForm = (body) => api.endpoints.PrintForm.post(body);
const GetServiceFormText = (body) => api.endpoints.GetServiceFormText.post(body);
const PrintCheckList = (body) => api.endpoints.PrintCheckList.post(body);
const GetCheckoutSituationForms = (body) => api.endpoints.GetCheckoutSituationForms.post(body);
const GetReceiptSituationForms = (body) => api.endpoints.GetReceiptSituationForms.post(body);
const GetOrderDetails = (body) => api.endpoints.GetOrderDetails.post(body);
const SubmitOrder = (body) => api.endpoints.SubmitOrder.post(body);
const GetCheckoutSelections = (body) => api.endpoints.GetCheckoutSelections.post(body);
const SetAdditionalInformation = (body) => api.endpoints.SetAdditionalInformation.post(body);
const GetCheckoutSituationId = (body) => api.endpoints.GetCheckoutSituationId.post(body);
const SetOrderForm = (body) => api.endpoints.SetOrderForm.post(body);
const ChangeOrderForm = (body) => api.endpoints.ChangeOrderForm.post(body);
const GetOrderSituationForms = (body) => api.endpoints.GetOrderSituationForms.post(body);
const PrintAllForms = (body) => api.endpoints.PrintAllForms.post(body);
const GetStatesWithFAST = () => api.endpoints.GetStatesWithFAST.post();
const GetAppPackageForms = (body) => api.endpoints.GetAppPackageForms.post(body);
const GetMiscellaneousForms = (body) => api.endpoints.GetMiscellaneousForms.post(body);

export {
  GetProductListAll,
  GetStateList,
  GetAnswerYesNoDontKnow,
  GetAnswerYesNo,
  GetAgeList,
  GetServiceForms,
  GetAnnuityTypeList,
  GetFundingSourceList,
  SaveIsd,
  SaveCareer,
  GetSilverGuardTypeList,
  GetGenderList,
  PrintForm,
  GetServiceFormText,
  PrintCheckList,
  GetCheckoutSituationForms,
  GetReceiptSituationForms,
  GetOrderDetails,
  SubmitOrder,
  GetCheckoutSelections,
  SetAdditionalInformation,
  GetCheckoutSituationId,
  SetOrderForm,
  ChangeOrderForm,
  GetOrderSituationForms,
  PrintAllForms,
  GetStatesWithFAST,
  GetAppPackageForms,
  GetMiscellaneousForms
};
